// Copyright 2026. WebPros International GmbH. All rights reserved.

import {
    OptionProps,
    PropsValue,
    components,
} from 'react-select';
import * as React from 'react';
import {
    computeResources,
    IComputeResourceResponse,
} from 'common/api/resources/ComputeResource';
import AsyncSelectInput from 'common/components/Select/AsyncSelectInput';
import { FILTERS } from 'admin/common/constants/tests';
import {
    ComputeResourceFilterOptionHost,
    FixedFormField,
} from 'admin/common/components/Filters/Styles';
import { Translate } from '@plesk/ui-library';
import { createOptionsLoader } from 'common/components/Select/helpers';

export interface IComputeResourceFilterProps {
    onChange?: (option: PropsValue<IComputeResourceFilterOptionType>) => void;
    value?: PropsValue<IComputeResourceFilterOptionType>;
}

export interface IComputeResourceFilterOptionType {
    label: string;
    value: string;
    host: string;
}

const OptionComponent = (props: OptionProps<IComputeResourceFilterOptionType>) => (
    <components.Option {...props}>
        <div>{props.data.label}</div>
        <ComputeResourceFilterOptionHost>{props.data.host}</ComputeResourceFilterOptionHost>
    </components.Option>
);

export const ComputeResourceFilter: React.FC<IComputeResourceFilterProps> = ({
    onChange,
    value,
}) => {
    const loadComputeResources = createOptionsLoader(
        computeResources.list,
        (item: IComputeResourceResponse): IComputeResourceFilterOptionType => ({
            label: item.name,
            value: item.id.toString(),
            host: item.host,
        })
    );

    return (
        <FixedFormField data-cy={FILTERS.COMPUTE_RESOURCE}>
            <AsyncSelectInput
                isClearable={true}
                placeholder={<Translate content="filters.computeResource"/>}
                loadOptions={loadComputeResources}
                onChange={onChange}
                debounceTimeout={1000}
                additional={{ page: 1 }}
                value={value}
                menuPosition="absolute"
                menuPortalTarget={document.body}
                components={{
                    Option: OptionComponent,
                }}
            />
        </FixedFormField>
    );
};
